import script from "./CtaBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./CtaBanner.vue?vue&type=script&setup=true&lang=js"

import "./CtaBanner.vue?vue&type=style&index=0&id=97fc946a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97fc946a"]])

export default __exports__